export var WorkspacePluginProvider;
(function (WorkspacePluginProvider) {
    WorkspacePluginProvider["JIRA"] = "jira";
    WorkspacePluginProvider["CONFLUENCE"] = "confluence";
    WorkspacePluginProvider["GMAIL"] = "gmail";
    WorkspacePluginProvider["YANDEX_MAIL"] = "yandex_mail";
    WorkspacePluginProvider["GITHUB"] = "github";
    WorkspacePluginProvider["CALENDAR"] = "calendar";
})(WorkspacePluginProvider || (WorkspacePluginProvider = {}));
//# sourceMappingURL=workspace-plugin-provider.enum.js.map